import i18n from "config/i18next";

i18n.addResources("es", "termsAndConditions", {
  title: "Términos y condiciones",
  subtitle: "Gestioná las versiones de términos y condiciones que los riders deben aceptar.",
  currentVersion: "Versión actual",
  uploadDate: "Fecha de carga",
  uploadedBy: "Subido por",
  fileName: "Nombre del archivo",
  noVersion: "Sin versión cargada",
  uploadSection: "Subir nueva versión",
  updateFile: "Actualización de archivo",
  versionLabel: "Número de versión",
  versionPlaceholder: "Ej: 2.4",
  fileLabel: "Términos y condiciones",
  selectFile: "Seleccionar archivo",
  loadFile: "Cargar archivo",
  fileSelected: "Archivo seleccionado",
  changeFile: "Cambiar archivo",
  uploadButton: "Subir términos y condiciones",
  successMessage: "Actualización de términos y condiciones exitosa.",
  errorMessage: "Error al subir términos y condiciones",
  invalidFileType: "El formato del archivo debe ser PDF y no puede superar los 5MB.",
  invalidVersion: "Ingrese una versión válida (Ej: 1.0, 2.3)",
  fileRequired: "Debe seleccionar un archivo PDF",
  onlyPdf: "Solo se permiten archivos PDF.",
  instructions: "Sube un nuevo archivo PDF con los términos y condiciones. Los pickers verán esta versión al registrarse.",
  versionHistory: "Historial de versiones",
  noVersions: "No hay versiones cargadas",
  version: "Versión",
  estado: "Estado",
  acciones: "Acciones",
  activa: "Activa",
  ver: "Ver",
  actualizar: "Actualizar",
  tooltipInfo: "Cuando cargues y actualices el \n archivo, la versión anterior se \n reemplazará automáticamente.",
  borrar: "Borrar",
  reemplazar: "Reemplazar",
  confirmUpdateTitle: "Revisá cuidadosamente los detalles antes de actualizar",
  confirmUpdateMessage: "Nombre del archivo cargado: <b style='word-break:break-all'>{{fileName}}</b>\nLa fecha y hora de actualización se registrarán al confirmar.",
  confirmDeleteTitle: "Estás por eliminar el archivo",
  confirmDeleteMessage: "¿Realmente querés eliminarlo?",
  loadingVersions: "Cargando versiones...",
  inactiva: "Inactiva",
  errorDownload: "Error al descargar el archivo",
});

